<div
  class="vh-100 vw-100 app-bg-img-full d-flex justify-content-center align-items center"
>
  <div
    class="col-xl-6 col-md-6 col-sm-10 col-xs-12 d-flex justify-content-center align-items-center"
  >
    <div class="card shadow">
      <div class="card-header font-weight-bold">{{ content["title"] }}</div>
      <div class="card-body d-flex flex-column">
        <div class="card-text" [innerHTML]="content['body']"></div>
        <div class="app-button-container mt-3 align-self-start">
          <button class="btn btn-dark" (click)="continue()">{{ label }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
